import { render, staticRenderFns } from "./ProfilePuzzles.vue?vue&type=template&id=34902960&scoped=true"
import script from "./ProfilePuzzles.vue?vue&type=script&lang=js"
export * from "./ProfilePuzzles.vue?vue&type=script&lang=js"
import style0 from "./ProfilePuzzles.vue?vue&type=style&index=0&id=34902960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34902960",
  null
  
)

export default component.exports